import Card from '@mui/material/Card';
import { CardContent } from '@mui/material';
import { makeStyles } from '@material-ui/styles';
import { getUser } from 'src/utils/Common';
import axios from 'src/utils/axios';
import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  Paper,
  Divider,
  TextField,
  Button,
  Backdrop,
  CircularProgress,
  Snackbar,
  TablePagination,
  Typography,
  Box,
  Tooltip,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Select,
  MenuItem,
  FormControl,
  InputLabel
} from '@material-ui/core';
import Alert from 'src/components/Alert';
import CloseIcon from '@material-ui/icons/Close';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';


const useStyles = makeStyles((theme) => ({
    root: {
      paddingTop: theme.spacing(3),
      paddingBottom: theme.spacing(3),
      fontFamily: "Segoe UI",
      width: '100%',
      height: '100%'
    },
    generalCards: {
      zIndex: 1
    },
    backdrop: {
      zIndex: 1500
    }
  
  }));

function DealerShippingPrices() {
  const classes = useStyles();
  const SessionUser = getUser();
  const history = useHistory();
  const [loading, setLoading] = React.useState(false);
  const [uyari, setUyari] = useState(false);
  const [uyariTip, setUyariTip] = React.useState('default');
  const [shippingPriceList,setShippingPriceList] = useState([]);
  const [updatePopupOpen, setUpdatePopupOpen] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [tutar, setTutar] = useState('');
  const [insertPopupOpen, setInsertPopupOpen] = useState(false);
  const [modelList, setModelList] = useState([]);
  const [selectedModelKodu, setSelectedModelKodu] = useState('');
  const [tutar2, setTutar2] = useState(0);
  const [responseMessage, setresponseMessage] = useState({
    ErrorCode: '0',
    ErrorDescription: 'success_message'
  });
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const getPriceList = () => {
    setLoading(true);
    axios.get(`GetDealerShippingPrices`)
      .then(response => {
        setLoading(false);
        var data = response.data;
        setShippingPriceList(Array.isArray(data) ? data : []);
      })
      .catch(error => {
        setLoading(false);
        return;
      });
  }
  useEffect(() => {
            getPriceList();
          }, []); 
  useEffect(() => {
    if (!insertPopupOpen) return;
    axios.get('GetDealerShippingModels')
      .then(response => {
        setModelList(response.data || []);
      })
      .catch(() => {
        setModelList([]);
      });
  }, [insertPopupOpen]);
  const handlePriceUpdate = (modelkodu,kulmodelkodu,model,tutar,degTar,kullanici) => {
    setSelectedRow({
      modelkodu,
      kulmodelkodu,
      model,
      tutar,
      degTar,
      kullanici
    });
    setTutar(tutar);
    setUpdatePopupOpen(true);
  }

  const handleModelInsert = () => {
    setSelectedModelKodu('');
    setTutar2(0);
    setInsertPopupOpen(true);
  };

  const setPriceUpdate = () => {
    if (!selectedRow) return;
    setLoading(true);
    const data = {
      ModelCode: selectedRow.modelkodu,
      Price: tutar,
      UserId: SessionUser?.UserId
    };
    axios
      .post('/SetDealerPrice', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(() => {
        setLoading(false);
        setUpdatePopupOpen(false);
        getPriceList();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const setModelInsert = () => {
    if (!selectedModelKodu) return;
    setLoading(true);
    const data = {
      ModelCode: selectedModelKodu,
      Price: tutar2,
      UserId: SessionUser?.UserId
    };
    axios
      .post('/SetDealerModel', data, {
        headers: { 'Content-Type': 'application/json' }
      })
      .then(() => {
        setLoading(false);
        setInsertPopupOpen(false);
        getPriceList();
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const handleModelDelete = (modelkodu) => {
    confirmAlert({
      message: 'Silmek istediginizden emin misiniz?',
      buttons: [
        {
          label: 'Evet',
          onClick: () => {
            setLoading(true);
            const data = {
              ModelCode: modelkodu
            };
            axios
              .post('/SetDealerModelDelete', data, {
                headers: { 'Content-Type': 'application/json' }
              })
              .then(() => {
                setLoading(false);
                getPriceList();
              })
              .catch(() => {
                setLoading(false);
              });
          }
        },
        {
          label: 'Hayir',
          onClick: () => { }
        }
      ]
    });
  };

  return (
    <>
      <Snackbar
        open={uyari}
        autoHideDuration={5000}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      >
        <Alert
          onClose={uyariKapat}
          variant={uyariTip}
          message={responseMessage}
        ></Alert>
      </Snackbar>
      <Card>
        <Backdrop className={classes.backdrop} open={loading}>
          <CircularProgress color="inherit" />
        </Backdrop>
        <br></br>
        <br></br>
        <Grid container justifyContent="center" style={{ marginTop: '5%' }}>
            <Grid item xs={12} md={12}></Grid>
             <Grid item xs={8} md={8}>
                    <TableContainer>
                    <Table stickyHeader aria-label="sticky table">
                      <TableHead>
                        <TableRow>
                        <TableCell className={classes.tableCell} align="left">
                          <Button
                            variant="contained"
                            style={{ color: '#FFFFFF', backgroundColor: '#4CAF50' }}
                            onClick={handleModelInsert}
                          >
                            Ana Grup Ekle
                          </Button>
                        </TableCell>
                        <TableCell className={classes.tableCell} align="left"> Model Kodu	                          </TableCell>
                        <TableCell className={classes.tableCell} align="left"> Model						  </TableCell>
                        <TableCell className={classes.tableCell} align="left"> Tutar					  </TableCell>
                        <TableCell className={classes.tableCell} align="left"> Son Değişiklik Tarihi				  </TableCell>
                        <TableCell className={classes.tableCell} align="left"> Son Değişiklik Yapan				  </TableCell>
                        <TableCell className={classes.tableCell} align="left"> </TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {shippingPriceList?.map((row)=> (
                        <TableRow>
                        <TableCell className={classes.tableCell} align="left"> <Button variant="contained" style={{ color: '#424242', backgroundColor: '#FF9800' }}
                                                                                      onClick={()=>handlePriceUpdate(row.MODEL_KODU,row.KUL_MODEL_KODU,row.MODEL,row.TUTAR,row.DEGISIKLIK_TARIHI,row.KULLANICI)}
                                                                                      >Düzenle</Button></TableCell>
                        <TableCell className={classes.tableCellBilgi} align="left">{row.KUL_MODEL_KODU}</TableCell>
                        <TableCell className={classes.tableCellBilgi} align="left">{row.MODEL}</TableCell>
                        <TableCell className={classes.tableCellBilgi} align="left">{row.TUTAR}</TableCell>
                        <TableCell className={classes.tableCellBilgi} align="left">{row.DEGISIKLIK_TARIHI}</TableCell>
                        <TableCell className={classes.tableCellBilgi} align="left">{row.KULLANICI}</TableCell>
                        <TableCell className={classes.tableCell} align="left">
                          <IconButton onClick={() => handleModelDelete(row.MODEL_KODU)}>
                            <CloseIcon style={{ color: '#D32F2F' }} />
                          </IconButton>
                        </TableCell>
                        </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                    </TableContainer>
                    </Grid>
        </Grid>
         <Dialog open={insertPopupOpen} onClose={() => setInsertPopupOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            Ana Grup Ekle
            <IconButton
              aria-label="close"
              onClick={() => setInsertPopupOpen(false)}
              style={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <FormControl fullWidth variant="outlined" size="small">
                  <InputLabel id="model-select-label">Ana Grup</InputLabel>
                  <Select
                    labelId="model-select-label"
                    value={selectedModelKodu}
                    onChange={(e) => setSelectedModelKodu(e.target.value)}
                    label="Ana Grup"
                  >
                    <MenuItem value="" disabled>Seciniz</MenuItem>
                    {modelList?.map((item) => (
                      <MenuItem key={item.MODEL_KODU} value={item.MODEL_KODU}>
                        {`${item.KUL_MODEL_KODU} - ${item.MODEL}`}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Tutar"
                  type="number"
                  value={tutar2}
                  onChange={(e) => setTutar2(e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setInsertPopupOpen(false)}>Kapat</Button>
            <Button
              color="primary"
              style={{
                color: '#424242',
                backgroundColor: selectedModelKodu ? '#FF9800' : '#BDBDBD'
              }}
              variant="contained"
              onClick={setModelInsert}
              disabled={!selectedModelKodu}
            >
              Kaydet
            </Button>
          </DialogActions>
        </Dialog>
         <Dialog open={updatePopupOpen} onClose={() => setUpdatePopupOpen(false)} maxWidth="sm" fullWidth>
          <DialogTitle>
            Fiyat Guncelle
            <IconButton
              aria-label="close"
              onClick={() => setUpdatePopupOpen(false)}
              style={{ position: 'absolute', right: 8, top: 8 }}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <DialogContent dividers>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField
                  label="Model Kodu"
                  value={selectedRow?.kulmodelkodu || ''}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Model"
                  value={selectedRow?.model || ''}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Tutar"
                  type="number"
                  value={tutar}
                  onChange={(e) => setTutar(e.target.value)}
                  fullWidth
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Son Degisiklik Tarihi"
                  value={selectedRow?.degTar || ''}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  label="Son Degisiklik Yapan"
                  value={selectedRow?.kullanici || ''}
                  fullWidth
                  InputProps={{ readOnly: true }}
                  variant="outlined"
                  size="small"
                />
              </Grid>
            </Grid>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setUpdatePopupOpen(false)}>Kapat</Button>
            <Button color="primary" style={{ color: '#424242', backgroundColor: '#FF9800' }} variant="contained" onClick={setPriceUpdate}>Kaydet</Button>
          </DialogActions>
        </Dialog>
      </Card>
    </>
  );
}

export default DealerShippingPrices;


